import React, { useCallback, ReactElement } from 'react';
import * as css from './RecommendedPanel.module.scss';
import 'src/css/themes.scss';
import { CheckedRECOMMENDED, ConnectedVehicleRec, ImportedRECOMMENDED } from 'src/models';
import { Checkbox } from '@framework-controls/core';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
    checkedRecommended: CheckedRECOMMENDED[];
    importedRecommended: ImportedRECOMMENDED[];
    mode: string;
    index: number;
    lastRecom: string;
    toggleRecommended: (code: string) => void;
}

const RecommendedPanel = (props: IProps) => {
    const recomChecked = props.checkedRecommended.some(result => (result.id ===
        props.connectedVehicle.recommended[props.index].id) ? true : false);
    const toggleRecommended = useCallback(() => {
        props.toggleRecommended(props.connectedVehicle.recommended[props.index].id);
    }, [props.toggleRecommended, props.index, props.connectedVehicle.recommended]);

    let recomCheckBox: ReactElement = <div></div>;

    if (props.mode !== 'P') {
        if (props.importedRecommended.findIndex((result => result.id === props.connectedVehicle.recommended[props.index].id)) !==
        -1) {
            recomCheckBox =
                <div className={css.checkboxArea}>
                    <div>
                        <Checkbox
                            id={'recomCheckbox'}
                            size={'sm'}
                            variant={'primaryCkb'}
                            checked={recomChecked}
                            onChange={toggleRecommended}>
                        </Checkbox>
                    </div>
                    <div className={css.asterisk}>*</div>
                </div>;
        } else {
            recomCheckBox =
                <div className={css.recomIcon}>
                    <Checkbox
                        id={'recomCheckbox'}
                        size={'sm'}
                        variant={'primaryCkb'}
                        checked={recomChecked}
                        onChange={toggleRecommended}>
                    </Checkbox>
                </div>;
        }
    }

    return (
        <div>
            <div className={css.dataRow}>
                {recomCheckBox}
                <div className={css.recomId}>{props.connectedVehicle.recommended[props.index].id}</div>
                <div className={css.recomDesc}>{props.connectedVehicle.recommended[props.index].desc}</div>
                <div className={css.recomSource}>{props.connectedVehicle.recommended[props.index].source}</div>
                <div className={css.recomStatus}>{props.connectedVehicle.recommended[props.index].status}</div>
                <div className={css.recomDueDate}>{props.connectedVehicle.recommended[props.index].dueDate}</div>
                <div className={css.recomDueMiles}>{props.connectedVehicle.recommended[props.index].dueMile}</div>
                <div className={css.recomOpCode}>{props.connectedVehicle.recommended[props.index].opCode}</div>
            </div>
            <hr className={props.connectedVehicle.recommended[props.index].id ===
                    props.lastRecom ? css.hidden : css.dataLine}></hr>
        </div>
    );
};

export default RecommendedPanel;